import React from "react";

export default function SideImage({ shift }) {
  return (
    <aside className={`aj-image ${shift ? "shift" : ""}`}>
      <img src="/media/img-profile-2.jpg" alt="AZ Shakil" />
    </aside>
  );
}
